import React from 'react';
import { Button, Dialog, DialogActions, Typography } from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import { themeStep } from 'features/step-menu/themeStep';
import styled from 'styled-components';

const MessageDialog = styled(Typography)`
  font-weight: 600;
  font-size: 17px;
  line-height: 22px;
  letter-spacing: -0.43px;
  line-height: 30px;
  text-align: center;
  color: ${themeStep.palette.grey[800]};
`;

const ButtonConfirm = styled(Button)`
  border: 1px solid ${themeStep.palette.grey[800]};
`;

const DialogActionsCustom = styled(DialogActions)`
  justify-content: flex-end;
  padding: 8px 16px 16px;
`;

interface IDialogComponentProps {
  message: string;
  openDialog: boolean;
  handleCancel: () => void;
  handleContinue: () => void;
}

const DialogComponent = ({
  message,
  openDialog,
  handleCancel,
  handleContinue,
}: IDialogComponentProps) => {
  return (
    <Dialog
      open={openDialog}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <MuiDialogTitle id="alert-dialog-title" style={{ maxWidth: '500px' }}>
        <MessageDialog style={{ fontSize: '16px', fontWeight: 500 }}>{message}</MessageDialog>
      </MuiDialogTitle>
      <DialogActionsCustom>
        <ButtonConfirm
          disabled={!openDialog}
          onClick={() => handleCancel()}
          style={{ backgroundColor: `${themeStep.palette.grey[900]}` }}
        >
          <Typography
            style={{ fontWeight: 500, color: `${themeStep.palette.grey[100]}`, lineHeight: 1 }}
          >
            No
          </Typography>
        </ButtonConfirm>
        <ButtonConfirm disabled={!openDialog} onClick={() => handleContinue()}>
          <Typography
            style={{ fontWeight: 500, color: `${themeStep.palette.grey[800]}`, lineHeight: 1 }}
          >
            Yes
          </Typography>
        </ButtonConfirm>
      </DialogActionsCustom>
    </Dialog>
  );
};

export default DialogComponent;
